import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useContent } from '../hooks/useContent';

const Privacy = () => {
  const { isDark } = useTheme();
  const { content, loading: contentLoading } = useContent('privacy');

  if (contentLoading || !content) {

    return (
      <div className={`pt-16 min-h-screen flex items-center justify-center ${isDark ? 'bg-dark-900' : 'bg-gray-50'}`}>
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-500"></div>
      </div>
    ); 
  }

  return (
    <div className={`pt-24 pb-16 min-h-screen ${
      isDark ? 'bg-dark-900 text-gray-100' : 'bg-gray-50 text-gray-900'
    }`}>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-10">
        <header className="text-center space-y-3">
          <p className={`text-sm font-semibold tracking-wide uppercase ${
            isDark ? 'text-primary-300' : 'text-primary-600'
          }`}>
            Quikr.it
          </p>
          <h1 className="text-3xl md:text-4xl font-bold">{content.pageTitle}</h1>
          <p className={`text-base md:text-lg ${
            isDark ? 'text-gray-300' : 'text-gray-600'
          }`}>
             {content.lastUpdate}
          </p>
        </header>

        {content.sections.map((section) => (
          <section
            key={section.title}
            className={`rounded-2xl border p-6 md:p-8 space-y-4 ${
              isDark ? 'bg-dark-800 border-dark-700' : 'bg-white border-gray-200 shadow-sm'
            }`}
          >
            <h2 className="text-2xl font-semibold">{section.title}</h2>
            {section.content?.map((paragraph, index) => (
              <p
                key={index}
                className={isDark ? 'text-gray-300 leading-relaxed' : 'text-gray-700 leading-relaxed'}
              >
                {paragraph}
              </p>
            ))}
            {section.list && (
              <ul className="list-disc pl-6 space-y-2 text-sm md:text-base">
                {section.list.map((item, index) => (
                  <li
                    key={index}
                    className={isDark ? 'text-gray-300' : 'text-gray-700'}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </section>
        ))}
      </div>
    </div>
  );
};

export default Privacy;

